import { render, staticRenderFns } from "./CpurchasingView.vue?vue&type=template&id=7171f81e&scoped=true"
import script from "./CpurchasingView.vue?vue&type=script&lang=js"
export * from "./CpurchasingView.vue?vue&type=script&lang=js"
import style0 from "./CpurchasingView.vue?vue&type=style&index=0&id=7171f81e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7171f81e",
  null
  
)

export default component.exports